/* eslint-disable no-multi-str */
import { TCMS } from '../../types/cms';
import { renderContent } from '../../utils/cms';

const content: Array<TCMS> = [
    {
        type: 'section-header',
        variant: 'h4',
        content: 'සතියේ පැනය',
    },
    {
        type: 'typography',
        variant: 'body1',
        // eslint-disable-next-line no-irregular-whitespace
        content: `\n\n –සෑම සතියකම අභියෝගාත්මක ගණිතමය ගැටලුවක් MCQ ගැටලුවක් ලෙස ඉදිරිපත් කෙරේ. එම MCQ ගැටලුව හා පිළිතුර  වෙබ් අඩවියේ එයට ලබා දී ඇති  පිළිතුරු 5 න් ඔබේ පිළිතුර තෝරා ඉන්පසු ඔබේ පිළිතුරු සඳහා ගණිතමය පැහැදිලි කිරීමක් ඉදිරිපත් කිරීමට හෝ ඉදිරිපත් නොකිරීමට තෝරා ගැනීමෙන් පසු සොයා ගත හැක. නිවැරදි පිළිතුර හා ගණිතමය පැහැදිලි කිරීම් සහිත පිළිතුරු යොමු කල යුතු අවසාන දිනට වයස අවුරුදු 18ට අඩු පළමු තුන්දෙනා සඳහා රු. 2000, රු. 1500 සහ රු. 1000 ත්‍යාග පිරිනැමේ. ( පිළිතුරු යොමු කල යුතු අවසාන දිනය ගැටලුව සමඟ දක්වා ඇත​.)\nඔබට මෙම ගැටලුව පිලිබඳ විවෟත මණ්ඩපයක (open forum) සාකඡ්චා කල හැක.  එම මණ්ඩපය  ගැටලුවක් සාකඡ්චා කිරීම සඳහා විවෟත වන්නේ එම ගැටලුව සඳහා පිළිතුරු යොමු කල යුතු අවසාන දිනට පසුවය.\n\n`,
    },
    {
        type: 'link',
        href: ' ',
        // eslint-disable-next-line no-irregular-whitespace
        content: `මණ්ඩපය(forum)  සඳහා සබැඳිය​(link):click here`,
    },
    {
        type: 'typography',
        variant: 'body1',
        // eslint-disable-next-line no-irregular-whitespace
        content: `\n\n ඔබට පහත සබැඳි (links) භාවිතයෙන් ගැටලුව බලා, පිලිතුර ලබා දිය හැක.\nතවද​,  ඔබගේ ලිඛිත පිළිතුර සහ ගණිතමය පැහැදිලි කිරීම ඔබේ නම, ලිපිනය, දුරකථන අංකය, ඊමේල් ලිපිනය, උපන දිනය, පාසැලේ නම සහ ශ්‍රේණිය සමඟ  පහත සඳහන් සාමාන්‍ය ලිපිනයට හෝ විද්‍යුත් ලිපිනයට හෝ යොමු කළ හැක.\n\nසාමාන්‍ය ලිපිනය:\nආචාර්ය චාණක්‍ය විජේරත්න\nගණිත දෙපාර්තමේන්තුව\nකොළඹ විශ්ව විද්‍යාලය\nකොළඹ 03.\n\nවිද්‍යුත් ලිපිනය:  cjw@maths.cmb.ac.lk\nපිලිතුර ලබා දීම සඳහා සබැඳින් (Links)\n\n`,
    },
    {
        type: 'link',
        href: ' ',
        content: `Problem of the week #1`,
    },
    {
        type: 'break',
    },
    {
        type: 'link',
        href: ' ',
        content: `Problem of the week #2`,
    },
    {
        type: 'break',
    },
    {
        type: 'link',
        href: ' ',
        content: `Problem of the week #3`,
    },
    {
        type: 'break',
    },
    {
        type: 'link',
        href: ' ',
        content: `Problem of the week #4`,
    },
    {
        type: 'break',
    },
    {
        type: 'link',
        href: ' ',
        content: `Problem of the week #5`,
    },
    {
        type: 'typography',
        variant: 'body1',
        // eslint-disable-next-line no-irregular-whitespace
        content: `\n\nපිළිතුරු ලබා දීමෙන් පසුත් ඔබට පහත සබැඳිය (link) භාවිතයෙන්, මෙතෙක් දක්වා සියලු ගැටලු කියවිය හැක​.\n\n`,
    },
    {
        type: 'link',
        href: ' ',
        content: `ගැටළු කියවීමට: click here`,
    },
];

const WeeklyQuizS = (): JSX.Element[] => {
    return renderContent(content);
};

export default WeeklyQuizS;
